export const NAV_LANG_ACTIVE = "NAV_LANG_ACTIVE"
export const NAV_LANG_INACTIVE = "NAV_LANG_INACTIVE"
export const NAV_SWITCH_SLIDER = "NAV_SWITCH_SLIDER"
export const ORDER_TYPE = "ORDER_TYPE"


export const SET_LOCALE = "SET_LOCALE"
export const LANGUAGES = "LANGUAGES"
export const LANGUAGES_FAIL = "LANGUAGES_FAIL"
export const LANGUAGES_SUCCESS = "LANGUAGES_SUCCESS"


export const NAV_MENU = "NAV_MENU"
export const ITEM_ORDER_TABLE = "ITEM_ORDER_TABLE"
export const PRODUCTIONS_ORDER = "PRODUCTIONS_ORDER"
export const SETTING_ACTIVE = "SETTING_ACTIVE"
export const SELECTED_CURRENCY = "SELECTED_CURRENCY"
export const SET_BASE_CURRENCY = "SET_BASE_CURRENCY"
export const MODIFY_ORDER = "MODIFY_ORDER"

export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS"
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR"

export const POPUP_ACTIVE = 'POPUP_ACTIVE'
export const HEADER_POPUP_ACTIVE = 'HEADER_POPUP_ACTIVE'
export const UPDATE_POP_STATUS = "UPDATE_POP_STATUS"

export const FETCH_PRODUCT_SUCCESS = "FETCH_PRODUCT_SUCCESS"
export const FETCH_PRODUCT_ERROR = "FETCH_PRODUCT_ERROR"
export const FETCH_PRODUCT_PENDING = "FETCH_PRODUCT_PENDING"
export const FETCH_DELETE_ITEM_SUCCUSS = "FETCH_DELETE_ITEM_SUCCUSS"
export const POST_APPLY_COUPON_SUCCESS = "POST_APPLY_COUPON_SUCCESS"
export const POST_APPLY_COUPON_ERROR = "POST_APPLY_COUPON_ERROR"

export const FETCH_ITEMS = "FETCH_ITEMS"
export const FETCH_MORE_ITEMS = "FETCH_MORE_ITEMS"
export const FETCH_PRODUCT = "FETCH_PRODUCT"
export const FETCH_MORE_PRODUCT_SUCCESS = "FETCH_MORE_PRODUCT_SUCCESS"
export const FETCH_SEARCH_PRODUCT = "FETCH_SEARCH_PRODUCT"

export const SUBMIT_ORDER = "SUBMIT_ORDER"
export const SUBMIT_ORDER_SUCCESS = "SUBMIT_ORDER_SUCCESS"
export const SUBMIT_ORDER_FAIL = "SUBMIT_ORDER_FAIL"

export const MANAGERS = "MANAGERS"
export const MANAGERS_SUCCESS = "MANAGERS_SUCCESS"
export const MANAGERS_FAIL = "MANAGERS_FAIL"

export const FETCH_ORDER_ITEMS_SUCCESS = "FETCH_ORDER_ITEMS_SUCCESS"
export const FETCH_NEW_ORDER_ITEMS_SUCCESS = "FETCH_NEW_ORDER_ITEMS_SUCCESS"
export const FETCH_ORDER_ITEMS_ERROR = "FETCH_ORDER_ITEMS_ERROR"
export const FETCH_ORDER_QTY_SUCCESS = "FETCH_ORDER_QTY_SUCCESS"
export const FETCH_UPDATE_ORDER_ITEM_SUCCESS = "FETCH_UPDATE_ORDER_ITEM_SUCCESS"

export const APPLY_PROMOTIONCODE = "APPLY_PROMOTIONCODE"
export const APPLY_PROMOTIONCODE_ERROR = "APPLY_PROMOTIONCODE_ERROR"
export const APPLY_PROMOTIONCODE_SUCCESS = "APPLY_PROMOTIONCODE_SUCCESS"


export const FETCH_ORDER_STATUS_SUCCESS = "FETCH_ORDER_STATUS_SUCCESS"
export const FETCH_ORDER_STATUS_ERROR = "FETCH_ORDER_STATUS_ERROR"
export const RESET_ORDER_ITEMS_STATE = "RESET_ORDER_ITEMS_STATE"
export const FETCH_MODIFIED_ORDER_ITEM = "FETCH_MODIFIED_ORDER_ITEM"

export const FETCH_CUSTOMER_STATUS_SUCCESS = "FETCH_CUSTOMER_STATUS_SUCCESS"
export const FETCH_CUSTOMER_STATUS_ERROR = "FETCH_CUSTOMER_STATUS_ERROR"
export const RESET_CUSTOMER_STATE = "RESET_CUSTOMER_STATE"

export const FETCH_LOCATION_STATUS_SUCCESS = "FETCH_LOCATION_STATUS_SUCCESS"
export const FETCH_LOCATION_STATUS_ERROR = "FETCH_LOCATION_STATUS_ERROR"
export const RESET_LOCATION_STATE = "RESET_LOCATION_STATE"

export const FETCH_LOCATION = "FETCH_LOCATION"
export const FETCH_LOCATION_FAILED = "FETCH_LOCATION_FAILED"
export const FETCH_LOCATION_SUCCESS = "FETCH_LOCATION_SUCCESS"
export const MUTATION_CHANGE_LOCATIONS_ACTION = "MUTATION_CHANGE_LOCATIONS_ACTION"

export const FETCH_SALE_ID = "FETCH_SALE_ID"
export const SUBMIT_CHANGE_LOCATIONS = "SUBMIT_CHANGE_LOCATIONS"
export const SAVE_ORDER_CHANGE_LOCATION_SUCCESS = "SAVE_ORDER_CHANGE_LOCATION_SUCCESS"
export const SAVE_ORDER_CHANGE_LOCATION_FAILD = "SAVE_ORDER_CHANGE_LOCATION_FAILD"

export const UPDATE_IS_PAID_ORDER = "UPDATE_IS_PAID_ORDER"
export const UPDATE_IS_PAID_ORDER_SUCCESS = "UPDATE_IS_PAID_ORDER_SUCCESS"
export const UPDATE_IS_PAID_ORDER_FAILD = "UPDATE_IS_PAID_ORDER_FAILD"


export const FETCH_CHILD_LOCATION = "FETCH_CHILD_LOCATION"
export const FETCH_CHILD_LOCATION_FAILED = "FETCH_CHILD_LOCATION_FAILD"
export const FETCH_CHILD_LOCATION_SUCCESS = "FETCH_CHILD_LOCATION_SUCCESS"

export const FETCH_CUSTOMER = "FETCH_CUSTOMER"
export const FETCH_CUSTOMER_FAILED = "FETCH_CUSTOMER_FAILED"
export const FETCH_CUSTOMER_SUCCESS = "FETCH_CUSTOMER_SUCCESS"
export const FETCH_SELECTED_CUSTOMER_NAME = "FETCH_SELECTED_CUSTOMER_NAME"
export const FETCH_SELECTED_CUSTOMER_ID = "FETCH_SELECTED_CUSTOMER_ID"
export const FETCH_SELECTED_LOCATION_NAME = "FETCH_SELECTED_LOCATION_NAME"
export const FETCH_SELECTED_LOCATION_ID = "FETCH_SELECTED_LOCATION_ID"

export const UPDATE_USER = "UPDATE_USER"
export const SAVE_TOKEN = "SAVE_TOKEN"
export const LOGOUT = "LOGOUT"
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS"
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE"
export const FETCH_USER_TOKEN = "FETCH_USER_TOKEN"
export const FETCH_CURRENCIES = "FETCH_CURRENCIES"
export const FETCH_USER_IS_VOID = "FETCH_USER_IS_VOID"
export const FETCH_USER_AVAILABLE_ACTION = "FETCH_USER_AVAILABLE_ACTION"
export const FETCH_USER_ACTIONS = "FETCH_USER_ACTIONS"

export const MUTATION_CLOSE_STATUS = "MUTATION_CLOSE_STATUS"
export const MUTATION_SHOW_STATUS = "MUTATION_SHOW_STATUS"
export const MUTATION_ITEMS_STATUS = "MUTATION_ITEMS_STATUS"
export const MUTATION_CUSTOMERS_STATUS = "MUTATION_CUSTOMERS_STATUS"
export const MUTATION_LOCATIONS_STATUS = "MUTATION_LOCATIONS_STATUS"
export const MUTATION_CATEGORY_STATUS = "MUTATION_CATEGORY_STATUS"
export const MUTATION_FOOTER_STATUS = "MUTATION_FOOTER_STATUS"
export const MUTATION_UPDATE_LOCATION_ACTION = "MUTATION_UPDATE_LOCATION_ACTION"

export const MUTATION_COMFIRM_POP_STATUS = "MUTATION_COMFIRM_POP_STATUS"
export const MUTATION_CANNEL_POP_STATUS = "MUTATION_CANNEL_POP_STATUS"
export const MUTATION_EDIT_ITEMS_POP_STATUS = "MUTATION_EDIT_ITEMS_POP_STATUS"
export const MUTATION_MINUS_QTY = "MUTATION_MINUS_QTY"
export const MUTATION_PLUS_QTY = "MUTATION_PLUS_QTY"

export const FETCH_CATEGORY_SUCCESS = "FETCH_CATEGORY_SUCCESS"
export const FETCH_CATEGORY_ERROR = "FETCH_CATEGORY_ERROR"
export const FETCH_CATEGORY_FILTER_SUCCESS = "FETCH_CATEGORY_FILTER_SUCCESS"
export const FETCH_CATEGORY_FILTER_ERROR = "FETCH_CATEGORY_FILTER_ERROR"

export const FETCH_ORDER_LIST = "FETCH_ORDER_LIST"
export const FETCH_ORDER_LIST_SUCCESS = "FETCH_ORDER_LIST_SUCCESS"
export const FETCH_ORDER_LIST_FAILED = "FETCH_ORDER_LIST_FAILED"
export const VOID_ORDER_SUCCESS = "VOID_ORDER_SUCCESS"
export const VOID_ORDER_FAILED = "VOID_ORDER_FAILED"
export const FETCH_VOID_ORDER_LIST = "FETCH_VOID_ORDER_LIST"
export const VOID_ORDER = "VOID_ORDER"

export const VOID_ITEM_SUCCESS = "VOID_ITEM_SUCCESS"
export const VOID_ITEM_FAILED = "VOID_ITEM_FAILED"
export const VOID_ITEM = "VOID_ITEM"

export const FETCH_UPDATE_ORDER_STATUS_SUCCESS = "FETCH_UPDATE_ORDER_STATUS_SUCCESS"
export const FETCH_UPDATE_ORDER_STATUS_FAILED = "FETCH_UPDATE_ORDER_STATUS_FAILED"
export const FETCH_UPDATE_ORDER_STATUS = "FETCH_UPDATE_ORDER_STATUS"

export const SET_FIREBASE_STATE = "SET_FIREBASE_STATE"
export const POPUP_CLOSE = "POPUP_CLOSE"
export const FETCH_PENDING_ORDER = "FETCH_PENDING_ORDER"
export const RESET_SALE_ITEM = "RESET_SALE_ITEM"
export const SET_COUNT_SALE = "SET_COUNT_SALE"

export const FETCH_PRE_INVOICE_ITEM = "FETCH_PRE_INVOICE_ITEM"
export const RESET_PRE_INVOICE_ITEM = "RESET_PRE_INVOICE_ITEM"


export const RESTAURANTS = "RESTAURANTS"
export const RESTAURANTS_FAIL = "RESTAURANTS_FAIL"
export const RESTAURANTS_SUCCESS = "RESTAURANTS_SUCCESS"

export const SELECT_RESTAURANT = "SELECT_RESTAURANT"

export const LOGIN = "LOGIN"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const MOVE_TABLE = "MOVE_TABLE"
export const MOVE_TABLE_FAIL = "MOVE_TABLE_FAIL"
export const MOVE_TABLE_SUCCESS = "MOVE_TABLE_SUCCESS"

export const CLEAR_AUTH = "CLEAR_AUTH"
export const CLEAR_ORDER = "CLEAR_ORDER"
export const ORDER = "ORDER"

export const CUSTOMER = "CUSTOMER"
export const CUSTOMER_FAIL = "CUSTOMER_FAIL"
export const CUSTOMER_SUCCESS = "CUSTOMER_SUCCESS"



export const DARSHBOARD = "DARSHBOARD"
export const DARSHBOARD_FAIL = "DARSHBOARD_FAIL"
export const DARSHBOARD_SUCCESS = "DARSHBOARD_SUCCESS"

export const DARSHBOARD_CATEGORY = "DARSHBOARD_CATEGORY"
export const DARSHBOARD_CATEGORY_FAIL = "DARSHBOARD_CATEGORY_FAIL"
export const DARSHBOARD_CATEGORY_SUCCESS = "DARSHBOARD_CATEGORY_SUCCESS"



export const GET_TABLE_STATUS = "GET_TABLE_STATUS"
export const GET_TABLE_STATUS_FAIL = "GET_TABLE_STATUS_FAIL"
export const GET_TABLE_STATUS_SUCCESS = "GET_TABLE_STATUS_SUCCESS"

export const GET_PROMOT_CODE = "GET_PROMOT_CODE"
export const CLEAR_PROMOT_CODE = "CLEAR_PROMOT_CODE"
export const GET_PROMOTION_OBJ = "GET_PROMOTION_OBJ"

export const CHECK_PROMOTE_AMOUNT = "CHECK_PROMOTE_AMOUNT"

export const CHECK_PROMOTIONCODE = "CHECK_PROMOTIONCODE"
export const CHECK_PROMOTIONCODE_SUCCESS = "CHECK_PROMOTIONCODE_SUCCESS"
export const CHECK_PROMOTIONCODE_ERROR = "CHECK_PROMOTIONCODE_ERROR"

export const STATUS_NOT_FOUND = "STATUS_NOT_FOUND"

export const STATUS_CODE = "STATUS_CODE"

export const CURRENCY_SUCCESS = "CURRENCY_SUCCESS"